/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface CreatePlaceDto
 */
export interface CreatePlaceDto {

    /**
     * Google Places unique identifier
     *
     * @type {string}
     * @memberof CreatePlaceDto
     */
    placeId: string;

    /**
     * @type {string}
     * @memberof CreatePlaceDto
     */
    name?: string;

    /**
     * @type {string}
     * @memberof CreatePlaceDto
     */
    formattedAddress?: string;

    /**
     * @type {string}
     * @memberof CreatePlaceDto
     */
    street?: string;

    /**
     * @type {string}
     * @memberof CreatePlaceDto
     */
    streetNumber?: string;

    /**
     * @type {string}
     * @memberof CreatePlaceDto
     */
    postalCode?: string;

    /**
     * @type {string}
     * @memberof CreatePlaceDto
     */
    city?: string;

    /**
     * @type {string}
     * @memberof CreatePlaceDto
     */
    province?: string;

    /**
     * @type {string}
     * @memberof CreatePlaceDto
     */
    country?: string;

    /**
     * Latitude (WGS84)
     *
     * @type {number}
     * @memberof CreatePlaceDto
     */
    lat: number;

    /**
     * Longitude (WGS84)
     *
     * @type {number}
     * @memberof CreatePlaceDto
     */
    lng: number;

    /**
     * @type {string}
     * @memberof CreatePlaceDto
     */
    note?: string;
}
